import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import WithRouter from '../Extensions/WithRouter';
import Loader from '../Loader/Loader';
import api from '../../api';
import './AddVersionModal.css';

class AddVersionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenMAV: props.isOpenMAV,
      projectId: props.projectId,
      projectNm: props.projectNM,
      versionError: '',
    };
    this.closeAddVersionModal = this.closeAddVersionModal.bind(this);
    this.addVersion = this.addVersion.bind(this);
    this.getByteLength = this.getByteLength.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMAV, projectId, projectNm } = this.props;
    if (prevProps.isOpenMAV !== isOpenMAV) {
      this.setState({
        isOpenMAV,
        projectId,
        projectNm,
      }, () => {
        this.initValue();
      });
    }
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += text.charCodeAt(i) > 128 ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  initValue() {
    this.setState({
      versionError: '',
    });
  }

  closeAddVersionModal() {
    const { closeModal } = this.props;
    this.setState({
      isOpenMAV: false,
    });
    closeModal();
  }

  addVersion() {
    const { projectId } = this.state;
    const { addCallback, translate } = this.props;
    const newVersion = this.versionName.value;
    /*
    const currentVersion = this.state.currentVersionList.find((item) => {
      return item.text === newVersion;
    });
    */
    this.initValue();
    if (newVersion.trim() === '') {
      this.setState({
        versionError: translate('modal.error.version_required'),
      });
      return false;
    }
    if (this.getByteLength(newVersion) > 20) {
      this.setState({
        versionError: translate('modal.error.version_limited_char'),
      });
      return false;
    }
    /*
    if (currentVersion) {
      this.setState({
        versionError: 'Version is already existed.',
      });
      return false;
    }*/

    const data = {
      id: projectId,
      name: newVersion,
    };

    api
      .addVersion(data)
      .then((response) => {
        this.closeAddVersionModal(true);
        if (addCallback) {
          addCallback(response.response);
        }
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error_description) {
          if (o.error === '422-366' && o.error_description.match('Duplicate')) {
            return this.setState({
              versionError: translate('modal.error.error_422_366'),
            });
          }
        }
        if (o.error && o.error === '422-362') {
          return this.setState({
            versionError: translate('modal.error.error_422_362'),
          });
        }

        return this.setState({
          versionError: translate('modal.error.unknow_error'),
        });
      });
  }

  render() {
    const { versionError, isOpenMAV, projectNm } = this.state;
    const { state, translate } = this.props;
    const versionErrorClass = versionError !== '' ? 'show' : '';
    if (state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal open={isOpenMAV} onClose={this.closeAddVersionModal}>
        <form className="frmAddVersion">
          <div className="add_popup">
            <div className="add_popup_item">
              <h2 className="title">{translate('modal.title.add_version')}</h2>
              <div className="add_popup_item_content">
                <p className="label">{translate('modal.title.project_name')}</p>
                <p className="value">
                  <input
                    type="text"
                    placeholder={translate('modal.place_holder.project_name')}
                    value={projectNm}
                    readOnly
                  />
                </p>
              </div>
              <div className="add_popup_item_content">
                <p className="label">{translate('modal.title.new_version')}</p>
                <p className={`value ${versionErrorClass}`}>
                  <input
                    ref={(ref) => {
                      this.versionName = ref;
                    }}
                    type="text"
                    placeholder={translate('modal.place_holder.version_name')}
                    //autoFocus
                  />
                  <div className={`error ${versionErrorClass}`}>{versionError}</div>
                </p>
              </div>
              <div className="add_popup_bottom">
                <a className="cancel" onClick={this.closeAddVersionModal} onKeyUp={this.closeAddVersionModal}>
                  {translate('modal.button.cancel')}
                </a>
                <a className="save" onClick={this.addVersion} onKeyUp={this.addVersion}>
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(AddVersionModal)));
